// Installable web app: registers public/sw.js (offline start, home-screen install; the manifest is
// linked in index.html). Production builds only, so the dev server never serves stale files.
// Not inside Telegram: a Mini App cannot be installed and needs the network for its sign-in anyway,
// and a worker there would only add a cache that Telegram's webviews keep in their own way.
export function registerServiceWorker(): void {
  const env = (import.meta as unknown as { env?: { PROD?: boolean } }).env;
  const inTelegram = !!(window as unknown as { Telegram?: { WebApp?: { initData?: string } } }).Telegram?.WebApp?.initData;
  if (!env?.PROD || inTelegram || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {}); // without it the app still works online
  });
}
